"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("../styles/Tab.css");
var _TabMenuRD = _interopRequireDefault(require("./TabMenuRD"));
var _reactRouterDom = require("react-router-dom");
var _dist = require("package_ui_ihm/dist");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
* Nom : TabRD.js
* Description : Ce fichier contient la définition du composant TabRD 
*               Ce composant est une barre de navigation avec des liens pour naviguer sur l'application coté R&D
*               qui s'affichent sous forme d'onglets
* Date de création : 23 septembre 2024
*/

/* CSS et assets */

/* Bibliothèques et composants */

/* Hook */

/**
* TabRD : ce composant est une barre de navigation avec des liens pour naviguer sur l'application 
*         qui s'affichent sous forme d'onglets
*
* Type : composant 
*
* Parametres : 
*  - tabNumber -- ce numéro permet d'identifier l’onglet actif correspondant à la section en cours pour l'afficher en vert. 
*                 Les autres onglets sont affichés en blanc.
*/function TabRD(_ref) {
  var tabNumber = _ref.tabNumber;
  // Define useScreenWidth hooks
  var screenWidth = (0, _dist.useScreenWidth)();

  // Render component
  if (tabNumber === 1) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-rd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/targets",
        className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: "Cibles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/trials",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Essais"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/rd-protocols",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Suggestions de protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TabMenuRD["default"], {
        classCss: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "tab-menu-disable",
          children: "Param\xE8tres"
        })
      })]
    });
  } else if (tabNumber === 2) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-rd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/targets",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Cibles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/trials",
        className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: "Essais"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/rd-protocols",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Suggestions de protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TabMenuRD["default"], {
        classCss: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "tab-menu-disable",
          children: "Param\xE8tres"
        })
      })]
    });
  } else if (tabNumber === 3) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-rd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/targets",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Cibles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/trials",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Essais"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/rd-protocols",
        className: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: "Suggestions de protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TabMenuRD["default"], {
        classCss: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "tab-menu-disable",
          children: "Param\xE8tres"
        })
      })]
    });
  } else if (tabNumber === 4) {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "tabs-rd",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/targets",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Cibles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/trials",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Essais"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactRouterDom.Link, {
        to: "/rd-protocols",
        className: screenWidth > 650 ? 'tab-disable' : 'tab-disable-ss',
        children: "Suggestions de protocoles"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_TabMenuRD["default"], {
        classCss: screenWidth > 650 ? 'tab-enable' : 'tab-enable-ss',
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "tab-menu-enable",
          children: "Param\xE8tres"
        })
      })]
    });
  }
}
var _default = exports["default"] = TabRD;